/**
 * State List.
 *
 * @format
 */

export const stateList = {
  Australia: [
    { name: 'NSW', value: 'New South Wales' },
    { name: 'VIC', value: 'Victoria' },
    { name: 'QLD', value: 'Queensland' },
    { name: 'TAS', value: 'Tasmania' },
    { name: 'SA', value: 'South Australia' },
    { name: 'WA', value: 'Western Australia' },
    { name: 'NT', value: 'Northern Territory' },
    { name: 'ACT', value: 'Australian Capital Territory' },
  ],
  Brazil: [
    { name: 'Acre', value: 'Acre' },
    { name: 'Alagoas', value: 'Alagoas' },
    { name: 'Amazonas', value: 'Amazonas' },
    { name: 'Amapá', value: 'Amapá' },
    { name: 'Bahia', value: 'Bahia' },
    { name: 'Ceará', value: 'Ceará' },
    { name: 'Distrito', value: 'Distrito Federal' },
    { name: 'Espírito', value: 'Espírito Santo' },
    { name: 'Goiás', value: 'Goiás' },
    { name: 'Maranhão', value: 'Maranhão' },
    { name: 'Minas', value: 'Minas Gerais' },
    { name: 'Mato', value: 'Mato Grosso do Sul' },
    { name: 'Mato', value: 'Mato Grosso' },
    { name: 'Pará', value: 'Pará' },
    { name: 'Paraíba', value: 'Paraíba' },
    { name: 'Pernambuco', value: 'Pernambuco' },
    { name: 'Piauí', value: 'Piauí' },
    { name: 'Paraná', value: 'Paraná' },
    { name: 'Rio', value: 'Rio de Janeiro' },
    { name: 'Rio', value: 'Rio Grande do Norte' },
    { name: 'Rondônia', value: 'Rondônia' },
    { name: 'Roraima', value: 'Roraima' },
    { name: 'Rio', value: 'Rio Grande do Sul' },
    { name: 'Santa', value: 'Santa Catarina' },
    { name: 'Sergipe', value: 'Sergipe' },
    { name: 'São', value: 'São Paulo' },
    { name: 'Tocantins', value: 'Tocantins' },
  ],
  Canada: [
    { name: 'AB', value: 'Alberta' },
    { name: 'BC', value: 'British Columbia' },
    { name: 'MB', value: 'Manitoba' },
    { name: 'NB', value: 'New Brunswick' },
    { name: 'NL', value: 'Newfoundland and Labrador' },
    { name: 'NT', value: 'Northwest Territories' },
    { name: 'NS', value: 'Nova Scotia' },
    { name: 'NU', value: 'Nunavut' },
    { name: 'ON', value: 'Ontario' },
    { name: 'PE', value: 'Prince Edward Island' },
    { name: 'QC', value: 'Quebec' },
    { name: 'SK', value: 'Saskatchewan' },
    { name: 'YT', value: 'Yukon Territory' },
  ],
  China: [
    { name: '安徽', value: 'Anhui' },
    { name: '福建', value: 'Fujian' },
    { name: '甘肃', value: 'Gansu' },
    { name: '广东', value: 'Guangdong' },
    { name: '贵州', value: 'Guizhou' },
    { name: '海南', value: 'Hainan' },
    { name: '河北', value: 'Hebei' },
    { name: '黑龙江', value: 'Heilongjiang' },
    { name: '河南', value: 'Henan' },
    { name: '湖北', value: 'Hubei' },
    { name: '湖南', value: 'Hunan' },
    { name: '江苏', value: 'Jiangsu' },
    { name: '江西', value: 'Jiangxi' },
    { name: '吉林', value: 'Jilin' },
    { name: '辽宁', value: 'Liaoning' },
    { name: '青海', value: 'Qinghai' },
    { name: '陕西', value: 'Shaanxi' },
    { name: '山东', value: 'Shandong' },
    { name: '山西', value: 'Shanxi' },
    { name: '四川', value: 'Sichuan' },
    { name: '云南', value: 'Yunnan' },
    { name: '浙江', value: 'Zhejiang' },
    { name: '台湾', value: 'Taiwa' },
    { name: '北京', value: 'Beijin' },
    { name: '上海', value: 'Shangha' },
    { name: '天津', value: 'Tianji' },
    { name: '重庆', value: 'Chongqin' },
    { name: '广西', value: 'Guangx' },
    { name: '内蒙古', value: 'Inner Mongoli' },
    { name: '宁夏', value: 'Ningxi' },
    { name: '西藏', value: 'Tibet' },
    { name: '新疆', value: 'Xinjiang' },
    { name: '香港', value: 'Hong Kong' },
    { name: '澳门', value: 'Macau' },
  ],
  France: [
    { name: 'Auvergne-Rhône-Alpes', value: 'Auvergne-Rhône-Alpes' },
    { name: 'Bourgogne-Franche-Comté', value: 'Bourgogne-Franche-Comté' },
    { name: 'Bretagne', value: 'Bretagne' },
    { name: 'Centre-Val de Loire', value: 'Centre-Val de Loire' },
    { name: 'Corse', value: 'Corse' },
    { name: 'Grand Est', value: 'Grand Est' },
    { name: 'Hauts-de-France', value: 'Hauts-de-France' },
    { name: 'Île-de-France', value: 'Île-de-France' },
    { name: 'Normandie', value: 'Normandie' },
    { name: 'Nouvelle-Aquitaine', value: 'Nouvelle-Aquitaine' },
    { name: 'Occitanie', value: 'Occitanie' },
    { name: 'Pays de la Loire', value: 'Pays de la Loire' },
    { name: "Provence-Alpe-Côtes d'Azur", value: "Provence-Alpe-Côtes d'Azur" },
  ],
  Germany: [
    { name: 'Baden-Württemberg', value: 'Baden-Württemberg' },
    { name: 'Bavaria', value: 'Bavaria' },
    { name: 'Berlin', value: 'Berlin' },
    { name: 'Brandenburg', value: 'Brandenburg' },
    { name: 'Bremen', value: 'Bremen' },
    { name: 'Hamburg', value: 'Hamburg' },
    { name: 'Hesse', value: 'Hesse' },
    { name: 'Lower Saxony', value: 'Lower Saxony' },
    {
      name: 'Mecklenburg-Western Pomerania',
      value: 'Mecklenburg-Western Pomerania',
    },
    { name: 'North Rhine-Westphalia', value: 'North Rhine-Westphalia' },
    { name: 'Rhineland-Palatinate', value: 'Rhineland-Palatinate' },
    { name: 'Saarland', value: 'Saarland' },
    { name: 'Saxony', value: 'Saxony' },
    { name: 'Saxony-Anhalt', value: 'Saxony-Anhalt' },
    { name: 'Schleswig-Holstein', value: 'Schleswig-Holstein' },
    { name: 'Thuringia', value: 'Thuringia' },
  ],
  Japan: [
    { name: '北海道', value: 'Hokkaidō' },
    { name: '青森県', value: 'Aomori' },
    { name: '岩手県', value: 'Iwate' },
    { name: '宮城県', value: 'Miyagi' },
    { name: '秋田県', value: 'Akita' },
    { name: '山形県', value: 'Yamagata' },
    { name: '福島県', value: 'Fukushima' },
    { name: '茨城県', value: 'Ibaraki' },
    { name: '栃木県', value: 'Tochigi' },
    { name: '群馬県', value: 'Gunma' },
    { name: '埼玉県', value: 'Saitama' },
    { name: '千葉県', value: 'Chiba' },
    { name: '東京都', value: 'Tōkyō' },
    { name: '神奈川県', value: 'Kanagawa' },
    { name: '新潟県', value: 'Niigata' },
    { name: '富山県', value: 'Toyama' },
    { name: '石川県', value: 'Ishikawa' },
    { name: '福井県', value: 'Fukui' },
    { name: '山梨県', value: 'Yamanashi' },
    { name: '長野県', value: 'Nagano' },
    { name: '岐阜県', value: 'Gifu' },
    { name: '静岡県', value: 'Shizuoka' },
    { name: '愛知県', value: 'Aichi' },
    { name: '三重県', value: 'Mie' },
    { name: '滋賀県', value: 'Shiga' },
    { name: '京都府', value: 'Kyōto' },
    { name: '大阪府', value: 'Ōsaka' },
    { name: '兵庫県', value: 'Hyōgo' },
    { name: '奈良県', value: 'Nara' },
    { name: '和歌山県', value: 'Wakayama' },
    { name: '鳥取県', value: 'Tottori' },
    { name: '島根県', value: 'Shimane' },
    { name: '岡山県', value: 'Okayama' },
    { name: '広島県', value: 'Hiroshima' },
    { name: '山口県', value: 'Yamaguchi' },
    { name: '徳島県', value: 'Tokushima' },
    { name: '香川県', value: 'Kagawa' },
    { name: '愛媛県', value: 'Ehime' },
    { name: '高知県', value: 'Kōchi' },
    { name: '福岡県', value: 'Fukuoka' },
    { name: '佐賀県', value: 'Saga' },
    { name: '長崎県', value: 'Nagasaki' },
    { name: '熊本県', value: 'Kumamoto' },
    { name: '大分県', value: 'Ōita' },
    { name: '宮崎県', value: 'Miyazaki' },
    { name: '鹿児島県', value: 'Kagoshima' },
    { name: '沖縄県', value: 'Okinawa' },
  ],
  'United States': [
    { name: 'AK', value: 'Alaska' },
    { name: 'AL', value: 'Alabama' },
    { name: 'AR', value: 'Arkansas' },
    { name: 'AS', value: 'American Samoa' },
    { name: 'AZ', value: 'Arizona' },
    { name: 'CA', value: 'California' },
    { name: 'CO', value: 'Colorado' },
    { name: 'CT', value: 'Connecticut' },
    { name: 'DC', value: 'District of Columbia' },
    { name: 'DE', value: 'Delaware' },
    { name: 'FL', value: 'Florida' },
    { name: 'GA', value: 'Georgia' },
    { name: 'GU', value: 'Guam' },
    { name: 'HI', value: 'Hawaii' },
    { name: 'IA', value: 'Iowa' },
    { name: 'ID', value: 'Idaho' },
    { name: 'IL', value: 'Illinois' },
    { name: 'IN', value: 'Indiana' },
    { name: 'KS', value: 'Kansas' },
    { name: 'KY', value: 'Kentucky' },
    { name: 'LA', value: 'Louisiana' },
    { name: 'MA', value: 'Massachusetts' },
    { name: 'MD', value: 'Maryland' },
    { name: 'ME', value: 'Maine' },
    { name: 'MI', value: 'Michigan' },
    { name: 'MN', value: 'Minnesota' },
    { name: 'MO', value: 'Missouri' },
    { name: 'MS', value: 'Mississippi' },
    { name: 'MT', value: 'Montana' },
    { name: 'NC', value: 'North Carolina' },
    { name: 'ND', value: 'North Dakota' },
    { name: 'NE', value: 'Nebraska' },
    { name: 'NH', value: 'New Hampshire' },
    { name: 'NJ', value: 'New Jersey' },
    { name: 'NM', value: 'New Mexico' },
    { name: 'NV', value: 'Nevada' },
    { name: 'NY', value: 'New York' },
    { name: 'OH', value: 'Ohio' },
    { name: 'OK', value: 'Oklahoma' },
    { name: 'OR', value: 'Oregon' },
    { name: 'PA', value: 'Pennsylvania' },
    { name: 'PR', value: 'Puerto Rico' },
    { name: 'RI', value: 'Rhode Island' },
    { name: 'SC', value: 'South Carolina' },
    { name: 'SD', value: 'South Dakota' },
    { name: 'TN', value: 'Tennessee' },
    { name: 'TX', value: 'Texas' },
    { name: 'UT', value: 'Utah' },
    { name: 'VA', value: 'Virginia' },
    { name: 'VI', value: 'Virgin Islands' },
    { name: 'VT', value: 'Vermont' },
    { name: 'WA', value: 'Washington' },
    { name: 'WI', value: 'Wisconsin' },
    { name: 'WV', value: 'West Virginia' },
    { name: 'WY', value: 'Wyoming' },
  ],
};
